<template>
<div  oncontextmenu="return false" onselectstart="return false" ondragstart="return false">
     <div id="app" style="padding:8px 15px 0">
    <!-- <input type="hidden" id="reid" :value="re_id"> -->
    <div class="container-fluid" >

        <div class="row" style="margin-bottom:5px;">
            <div class="col-sm-6" style="background: #fff;padding: 10px">
                <div class="tuiBtn" @click="jump('jiaoanx2')">推荐课程</div>
            </div>
            <div class="col-sm-6" style="background: #ededed;padding: 10px">
                <div class="tuiBtn backp" @click="jump('jiaoan3')">查看教案</div>

            </div>

            <div class="col-sm-12" style="padding-left: 0" >
                <div style="background: #fff;height: 10px;border-top-right-radius: 20px;"></div>
            </div>
        </div>

        <div class="row" v-show="tab1_Show">
            <div class="col-sm-3" style="padding: 0">
                <div class="fix">
                    <div class="btn-group" style="width: 48%">
                        <button type="button" class="btna  dropdown-toggle kezhuang1"
                            data-toggle="dropdown" style="width: 100%">
                            课程系列 <!--<span class="caret"></span>-->
                        </button>
                        <!--<ul class="dropdown-menu dropm1" role="menu"  style="min-width: 0;margin: 0">-->
                            <!--<li><a href="javascript:;" >未备课</a></li>-->
                            <!--<li><a href="javascript:;" >备课中</a></li>-->
                        <!--</ul>-->
                    </div>
                    <div class="btn-group "  style="width: 48%;float: right">
                        <button type="button" class="btna  dropdown-toggle kezhuang2"
                            data-toggle="dropdown" style="width: 100%">
                            <span>全部课程</span>
                        </button>
                    </div>
                </div>
                <div class="fix">
                    <div style="width: 48%;float: left">
                        <!--v-bind:class="{active1:(ke.kc_id==kcid)}"-->
                        <div class="kelist hang1" v-for="(ke,index) in quanke1" :class="{active1:(ke.classa == classname)}"
                             @click="ke1(ke.classa)" v-cloak >
                             {{ke.classa}}
                        </div>
                    </div>
                    <div style="width: 48%;float: right">
                        <div class="kelist hang1 "  v-for="(item,index) in quanke2" :class="{active2:(item.kc_id == iiid)}"
                            @click="ke2(item.kc_id)" v-cloak>
                            {{item.title}}
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-sm-9">
                <div >
                    <div class="conTitle " style="height: 85px;line-height: 85px;border-radius: 10px;background: #fff;padding-left: 44px;padding-right: 44px">
                        <el-select v-model="value8" filterable @change="tanaa"  placeholder="请输入姓名">
                            <el-option
                                v-for="item in options"
                                :key="item.user_id"
                                :label="item.username"
                                :value="item.user_id">
                            </el-option>
                        </el-select>
                        <div class="youanniu" v-if="!value8">推荐课程</div>
                        <div class="youanniu2" v-if="value8" @click="tuijian()">推荐课程</div>
                    </div>
                    <div class="container-fluid">
                        <div class="row fix" id="kebox" style="background: #fff;padding:15px 0 0 40px;min-height: 300px">
                            <p style="padding-bottom: 20px;color: #999">
                                <span class="fa fa-warning"></span>请选择需要推荐的课程
                            </p>
                            <div class="ke" v-for=" quan in quankk" :aid="quan.id" v-on:click="xuanz($event)" v-bind:class="{active111:(quan.status==1)}">
                                {{quan.title}}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!--<el-button :plain="true" @click="open" style="display: none">打开消息提示</el-button>-->

</div>
</div>
</template>

<script>
    var shabilz = 0;
    setInterval(function() {
    shabilz++;
    }, 1000);

// $(window).bind('beforeunload', function(){
//     var reid= $('#reid').val()
//     $.ajax({
//         url:process.env.apiUrl + "saas/jiaoan/tl",
//         type:"post",
//         dataType:'json',
//         data:{
//             time:shabilz,
//             re_id:reid,
//             token:
//         },
//         success:function(data){

//         }
//     });
// });

    export default {
        data() {
            return {
                options: "",
                value8: "",
                title: "",
                kechengname: "",
                iid: "",
                kcid: "",
                quanke1: "",
                quanke2: "",
                is_sc: 0,
                is_bk: 0,
                kecheng2: "全部课程",
                ydrs: "",
                shouc: "",
                zhengwen: "",
                re_id: "",
                shipp: "",
                ships: "",
                shipe: "",
                audioe: "",
                fendata: "",
                audio: "",
                play_auth: "",
                player: "",
                classname: "",
                iiid: "",
                quankk: "",
                ids: "",
                token: "",
                tab1_Show: true,
                tab2_Show: false,
            };
        },
        created() {
            let self = this;
            self.token = self.$cookies.get("token");
        },
        methods: {
            tabs(i) {},
            jump:function (d) {
                this.$router.push(d)
            },
            xuanz: function(event) {
            //          alert($(event.currentTarget).index())
            var ind = $(event.currentTarget).index() - 1;
            if (this.quankk[ind].status == 2) {
                this.quankk[ind].status = 1;
            } else {
                this.quankk[ind].status = 2;
            }

            //
            //                $res = $(event.currentTarget).hasClass('active111');
            //                if($res){
            //                    $(event.currentTarget).removeClass('active111');
            //                }else{
            //                    $(event.currentTarget).addClass('active111');
            //                }
            },
            tuijian: function() {
                var actives = $(".active111");
                var ids = new Array();
                // actives.each(function () {
                //     ids.push($(this).attr('aid'));
                // })
                for (var i = 0; i < actives.length; i++) {
                    ids.push(actives.eq(i).attr("aid"));
                }

                var self = this;
                self.ids = ids;

                $.ajax({
                    url: process.env.apiUrl + "saas/jiaoan/refer_lesson",
                    type: "post",
                    dataType: "json",
                    data: {
                        userid: self.value8,
                        iiid: self.iiid,
                        ids: self.ids,
                        token: self.token
                    },
                    success: function(data) {
                        console.log(data);
                        // self.$message('提交成功！');
                        // this.$message('提交成功！');
                        if (data == 1) {
                            self.$message({
                                message: "提交成功",
                                type: "success"
                            });
                        } else {
                            self.$message({
                                message: "提交失败",
                                type: "warning"
                            });
                        }

                        ids.length = 0;
                        self.ids = "";
                    }
                });
            },
            tanaa: function() {
                var self = this;
                $.ajax({
                    url: process.env.apiUrl + "saas/jiaoan/get_staff_refer",
                    type: "post",
                    dataType: "json",
                    data: {
                        userid: self.value8,
                        kc_id: self.iiid,
                        token: self.token
                    },
                    success: function(data) {
                    //    $('.active111').each(function(){
                    //        $(this).removeClass('active111');
                    //    })
                        console.log(data);
                        self.quankk = data;
                    }
                });
            },

            ke1: function(cl) {
                var self = this;
                self.classname = cl;
                $.ajax({
                    url: process.env.apiUrl + "saas/jiaoan/get_titles",
                    type: "post",
                    dataType: "json",
                    data: {
                        classname: self.classname,
                        token: self.token
                    },
                    success: function(data) {
                    self.quanke2 = data.data;
                    }
                });
            },
            ke2: function(id) {
            var self = this;
            self.iiid = id;

            $.ajax({
                url: process.env.apiUrl + "saas/jiaoan/get_staff_refer",
                type: "post",
                dataType: "json",
                data: {
                    userid: self.value8,
                    kc_id: id,
                    token: self.token
                },
                success: function(data) {
                console.log(data);
                //$('#kebox').empty()
                //                        $('.active111').each(function(){
                //                            $(this).removeClass('active111');
                //                        })
                self.quankk = data;
                }
            });
            }
        },
        beforeCreate: function() {
            this.token = this.$cookies.get("token");

            var self = this;
            $.ajax({
                url: process.env.apiUrl + "saas/jiaoan/get_classes",
                type: "post",
                dataType: "json",
                data: {
                    token: self.token
                },
                success: function(data) {
                    self.classname = data.data[0].classa;
                    self.quanke1 = data.data;

                    $.ajax({
                        url: process.env.apiUrl + "saas/jiaoan/get_titles",
                        type: "post",
                        dataType: "json",
                        data: {
                            classname: self.classname,
                            token: self.token
                        },
                        success: function(data) {
                            self.iiid = data.data[0].kc_id;
                            self.quanke2 = data.data;

                            $.ajax({
                                url: process.env.apiUrl + "saas/jiaoan/get_lessones",
                                type: "post",
                                dataType: "json",
                                data: {
                                    kc_id: self.iiid,
                                    token: self.token
                                },
                                success: function(data) {
                                    //                                    console.log(data)
                                    self.quankk = data.data;
                                }
                            });
                        }
                    });
                }
            });
            $.ajax({
                url: process.env.apiUrl + "saas/jiaoan/get_staff",
                type: "post",
                dataType: "json",
                data: {
                    token: self.token
                },
                success: function(data) {
                    self.options = data.data;
                }
            });
        }
    };
</script>
<style scoped>
[v-cloak] {
    display: none;
}
*{
    margin: 0;
    padding: 0;
    font-size: 14px;
    font-family: "微软雅黑";
}


.fl{
    float: left;
}
.hang1{
    overflow: hidden;
    text-overflow:ellipsis;
    white-space: nowrap;
}
.hang2{
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
}
.hang3{
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
}
p,label{margin: 0;padding: 0}
body{
    background:#ededed;
}

.btna{
    display: inline-block;
    padding: 6px 12px;
    margin-bottom: 0;
    font-size: 14px;
    font-weight: 400;
    line-height: 1.42857143;
    text-align: center;
    white-space: nowrap;
    vertical-align: middle;
    -ms-touch-action: manipulation;
    touch-action: manipulation;
    cursor: pointer;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    background-image: none;
    border: 1px solid transparent;
    border-radius: 4px;
}
.kezhuang1{
    background: #00cce4;
    color: #fff;
}
body .dropdown-menu>li>a{
    line-height:28px;
}


.kezhuang2{
    background: #ff797c;
    color: #fff;
}

.dropm1,.dropm2{
    width: 100%;
    padding: 0;
}
.dropm1{
    border: 1px solid #fdb06a;
    border-radius: 0 0 5px 5px;

}
.dropm2{
    border: 1px solid #79c4c7;
    border-radius: 0 0 5px 5px;
}
.dropm1 li{
    border-bottom: 1px solid #fdb06a ;
    height: 40px;
    line-height: 40px;
    text-align: center;
}
.dropm2 li{
    border-bottom: 1px solid #79c4c7 ;
    height: 40px;
    line-height: 40px;
    text-align: center;
}
.dropdown-menu>li>a{
    padding: 5px 20px;
}
.kelist{
    cursor: pointer;
    width: 100%;
    height: 40px;
    line-height: 40px;
    background: #fff;
    border-radius: 5px;
    text-align: center;
    color: #999;
    margin-bottom: 3px;
}
.kelist.active1{
    color: #00cce4;
    box-shadow: 0 3px 10px #8ae3ed;
}
.kelist.active2{
    color: #ff797c;
    box-shadow: 0 3px 10px #e9afb0;
}
.conTitle{

   font-size: 20px;
    margin-bottom:4px ;
}
.zidBtn {
    height: 30px;
    width: 104px;
    text-align: center;
    line-height: 30px;
    border-radius: 15px;
    font-size: 14px;
    color: #fff;
    border: none;
    margin: 30px 20px 0 0;
    cursor: pointer;
}
.zidg{
    background:#ff797c;
}
.zidy{
    background:#00cce4;
}
.titleListBox{
    /*border-bottom: 2px solid #fff;*/
    /*border-right: 2px solid #fff;*/
    border-radius: 10px;
    background: #fff;
}
.titleList{
    float: left;
    width: 33.33%;

    height: 50px;
    line-height: 50px;
    padding-left:22px ;
    cursor: pointer;
}

/*上下的按钮*/
.neirong::-webkit-scrollbar {
    display: none;

}/*导航条样式宽度*/
.neirong::-webkit-scrollbar-button    {
    display: none;

}/*上下的按钮*/

.neirong::-webkit-scrollbar-track     {
    /*background:#FF66D5;*/
    display: none;
}/*导航条样式颜色*/

.neirong::-webkit-scrollbar-thumb{
    display: none;
}/*滚动条样式颜色*/
.neirong::-webkit-scrollbar-corner {
    display: none;
}


.zhengwen{
    background: #fff;
    border-radius:10px;
   padding-left: 10px;
    margin-bottom: 4px;
}
.title11{
    line-height: 50px;
    font-size: 18px;
}
.neirong11{
    padding-left:35px;
    padding-bottom: 10px;

}


.neirong{
    overflow-y:scroll;
    background: #eee;
    padding: 20px;
}

    .tuiBtn {
        width: 190px;
        height: 40px;
        text-align: center;
        font-size: 20px;
        line-height: 40px;
        border-radius: 20px;
        background: #E6BE8A;
        color: #fff;
        margin: 0 auto;
        cursor: pointer;
        box-shadow: 0 3px 10px #a4a3aa;
    }

    .backp {
        background: #f1f1f1;
        color: #000;
    }
    .el-input__inner {
        height: 34px;
        border-radius: 20px;
        border: 1px solid #E6BE8A;
        color: #666;
    }

    /* WebKit browsers */
    .el-input__inner::-webkit-input-placeholder {
        font-size: 16px;
        color: #999;
    }
    /* Mozilla Firefox 4 to 18 */
    .el-input__inner:-moz-placeholder {
        font-size: 16px;
        color: #999;
    }
    /* Internet Explorer 10+ */
    .el-input__inner:-ms-input-placeholder {
        font-size: 16px;
        color: #999;
    }

    .youanniu {
        background: #ededed;
        color: #999;
        line-height: 34px;
        text-align: center;
        border-radius: 17px;
        float: right;
        margin-top: 25px;
        padding-left: 20px;
        padding-right: 20px;
        cursor: pointer;
    }
    .youanniu2 {
        background: #E6BE8A;
        color: #fff;
        line-height: 34px;
        text-align: center;
        border-radius: 17px;
        float: right;
        margin-top: 25px;
        padding-left: 20px;
        padding-right: 20px;
        cursor: pointer;
    }
    .ke {
        width: 134px;
        height: 60px;
        box-shadow: 0 5px 15px #e2e2e2;
        text-align: center;
        line-height: 60px;
        background: #fff;
        margin-right: 20px;
        margin-bottom: 34px;
        border-radius: 10px;
        float: left;
    }
    .ke.active111 {
        background: #f1f1f1;
    }
    .el-select > .el-input {
        display: block;
        height: 60px;
    }
    .el-select-dropdown__item{
        padding-left: 20px;
    }
    .el-scrollbar{
        padding-bottom: 20px;
    }

    @media screen and (min-width: 1501px) {
    .neirong{
        height: 78vh;
    }
	}

	@media screen and (max-width: 1499px) and(min-width: 1366px)  {
	    .neirong{
	        height: 360px;
	    }
	}

	@media screen and (max-width: 1367px)   {
	    .neirong{
	        height:300px
	    }
	}
</style>



// WEBPACK FOOTER //
// src/pages/jiaoan/jiaoanx2.vue